import React from 'react'
import { Tag } from 'antd'
import { CrownOutlined } from '@ant-design/icons'
import i from '../../translations/i'
import { SubscriptionStatus, days, formatDate, subscriptionStatusColor } from './billing.helpers'
import './billing.less'

/** Подписка в том виде, в каком её отдаёт GET /billing и /billing/status */
export interface SubscriptionView {
    level: number | null
    plan_name: string | null
    paid_until: string | null
    status: SubscriptionStatus
    days_left: number | null
}

/**
 * Плашка «Текущий тариф» — одна и та же в разделе оплаты и на рабочем столе.
 * Кнопку передаёт страница: в разделе оплаты она открывает оформление, на рабочем столе ведёт в раздел.
 */
export const SubscriptionCard = ({ subscription, action }: { subscription: SubscriptionView, action?: React.ReactNode }) => {
    const description = () => {
        switch (subscription.status) {
            case 'active':
            case 'expiring':
                return i.t('billing:subscription.paidUntil', { date: formatDate(subscription.paid_until), left: days(subscription.days_left ?? 0) })
            case 'expired':
                return i.t('billing:subscription.expiredAt', { date: formatDate(subscription.paid_until) })
            default:
                return i.t('billing:subscription.notPaid')
        }
    }

    return (
        <div className={`billing-current billing-current--${subscription.status}`}>
            <div className="billing-current__icon"><CrownOutlined /></div>
            <div className="billing-current__body">
                <div className="billing-current__label">{i.t('billing:subscription.title')}</div>
                <div className="billing-current__name">
                    {subscription.plan_name ?? i.t('billing:subscription.noPlan')}
                    <Tag color={subscriptionStatusColor(subscription.status)} className="billing-current__tag">
                        {i.t(`billing:subscription.status.${subscription.status}`)}
                    </Tag>
                </div>
                <div className="billing-current__text">{description()}</div>
            </div>
            {action && <div className="billing-current__actions">{action}</div>}
        </div>
    )
}
